export interface IGaShellShadowsConfig {
    top?: boolean;
    left?: boolean;
    right?: boolean;
}

export class GaShellConfig {
    shadows?: IGaShellShadowsConfig;

    constructor(options?: Partial<GaShellConfig>) {
        this.shadows = options?.shadows ?? {};
    }
}

export const defaultGaShellConfig: GaShellConfig = new GaShellConfig({
    shadows: {
        left: true,
        top: true,
        right: true
    }
});
